module.exports = __webpack_public_path__ + "static/chunks/algorithm.9c55122c241add6516fa.worker.js"